module.exports = __webpack_public_path__ + "img/22_54.7cb2f39c.png";